import { genericActions } from "../../_actions/generic.actions";
import { clockinService } from "../../_services/clockin.service";
import { ClockinStore } from "./ClockinStore";
import { Selectors } from "../../_reducers/app.reducer";
import { WorkdayMapper } from "../../_mappersTS/WorkdayMapper";
import { ClockinDateFilterStore } from "./ClockinDateFilterStore";
import { ClockinUserUidStore } from "./ClockinUserUidStore";
import { globalActions, uiAlertActions } from "../../_actions";
import { GLOBAL_POPUPS } from "../../_constants";
import { ClockinUserMapper } from "../../_mappers/ClockinUserMapper";
import { ClockinUsersStore } from "./ClockinUsersStore";
import { ClockinUser } from "../../_models/ClockinUser";
import { i18n } from "../../_translations/i18n";
import { DownloadHelper } from "../../../Budgets/_helpers";
import { ClockinsSecondaryViewStore } from "../ClockinsSecondaryViewStore";
import { appPermissions } from '../../_constants/permissions.constants';
import { ClockinFiltersStore } from "./ClockinFiltersStore";
import { ClockinVacationStore } from "./ClockinVacationStore";
import { ClockinWorkingCalendarStore } from "./ClockinWorkingCalendarStore";
import { VacationMapper } from "../../_mappersTS/VacationMapper";
import { WorkingCalendarEntriesMapper } from "../../_mappersTS/WorkingCalendarMapper";
import { ClockinWorkShiftMapper } from "../../_mappers/ClockinWorkShiftMapper";
import { ClockinWorkShiftStore } from "./ClockinWorkShiftStore";
import { WorkShiftMapper } from "../../_mappersTS/WorkShiftMapper";
import { AuthorizationMapper } from "../../_mappersTS/AuthorizationMapper";
import { AuthorizationStore } from "./AuthorizationStore";

export const ClockinActions = {
    //PUBLIC REMOTE
    createClockInForCurrentUser,
    refreshClockins,
    listClockins,
    listClockinUsers,
    createClockIn,
    createRemoteClockin,
    toggleFlexibleClockins,

    toggleRemoteAccess,
    setUserAllowsRemoteClockins: setUserClockinSettings,

    updateWeeklyClockinHours,
    updateMonthlyClockinHours,
    updateWorkLocationPolicy,
    updateUserClockinSettings,

    updateClockIn,
    deleteClockIn,

    uploadContract,
    deleteContract,

    openPdfReport,
    downloadPdfReport,
    downloadCSVReport,
    downloadExcelReport,

    requestVacation,
    listVacation,
    deleteVacation,

    addWorkingCalendarEntry,
    listWorkingCalendarEntries,
    deleteWorkingCalendarEntry,

    addWorkShiftSlot,
    listWorkShifts,
    deleteWorkShiftSlot,

    listAuthorizations,

    //PUBLIC LOCAL
    selectUserUid: ClockinUserUidStore.actions.setUserUid,
    setDateFilter: ClockinDateFilterStore.actionSetBeginEnd,
    showDeletePopUp,
    changeSecondaryView: ClockinsSecondaryViewStore.actionSet,
    changeFilter: ClockinFiltersStore.actionSet,

    //LOCAL PRIVATE
    _updateUserSuccess: ClockinStore.actionUpdateItemSuccess,
    _listClockinsSuccess: ClockinStore.actionListItemsSuccess,
    _listClockinUsersSuccess: ClockinUsersStore.actionListItemsSuccess,
    _listClockinVacationSuccess: ClockinVacationStore.actionListItemsSuccess,
    _listClockinWorkingCalendarEntriesSuccess: ClockinWorkingCalendarStore.actionListItemsSuccess,
    _listClockinWorkShiftSuccess: ClockinWorkShiftStore.actionListItemsSuccess,
    _listAuthorizationSuccess: AuthorizationStore.actionListItemsSuccess,
};

function openPdfReport(locationUid, userUid, begin, end, allUsersReport) {
    return getReportPdf(locationUid, userUid, begin, end, allUsersReport, false);
}

function downloadPdfReport(locationUid, userUid, begin, end, allUsersReport) {
    return getReportPdf(locationUid, userUid, begin, end, allUsersReport, true);
}

function getReportPdf(locationUid, userUid, begin, end, allUsersReport, isDownload) {
    return async dispatch => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const pdfBlob = (allUsersReport)
            ? await clockinService.getPdfBlobSummaryReport(locationUid, begin, end)
            : await clockinService.getPdfBlobUserReport(locationUid, userUid, begin, end);
            DownloadHelper.openOrDownloadBlob(pdfBlob, isDownload, i18n.t("global_report"));
        }
    };
}

function downloadCSVReport(locationUid, begin, end) {
    return async dispatch => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const isDownload = true;
            const csvBlob = await clockinService.getCSVBlobSummaryReport(locationUid, begin, end);
            DownloadHelper.openOrDownloadBlob(csvBlob, isDownload, i18n.t("global_export"));
        }
    };
}

function downloadExcelReport(locationUid, begin, end) {
    return async dispatch => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const isDownload = true;
            const excelBlob = await clockinService.getExcelBlobSummaryReport(locationUid, begin, end);
            DownloadHelper.openOrDownloadBlob(excelBlob, isDownload, i18n.t("global_export"));
        }
    };
}

function createRemoteClockin(locationUid) {
    return async dispatch => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await clockinService.createClockIn(locationUid);
            await dispatch(wiredListClockins());
            dispatch(uiAlertActions.success(
                i18n.t("mod_clockins_remote_clockin_successful"))
            );
        }
    };
}

function wiredListClockins() {
    return (dispatch, getState) => {
        const { begin, end } = Selectors.getClockinsDateFilter(getState());
        return dispatch(ClockinActions.listClockins(
            Selectors.getSelectedLocationUid(getState()),
            begin,
            end,
            Selectors.getClockinsSelectedUserUid(getState()),
        ));
    };
}

function toggleRemoteAccess(clockinUser = ClockinUser(), locationUid) {
    return setUserClockinSettings(
        locationUid,
        clockinUser.uid,
        !clockinUser.settings.allowsRemoteClockins,
        clockinUser.settings.hasFlexibleClockins,
        clockinUser.settings.weeklyClockinHours,
        clockinUser.settings.monthlyClockinHours,
        clockinUser.settings.workLocationPolicy,
    )
}

function toggleFlexibleClockins(clockinUser = ClockinUser(), locationUid) {
    return setUserClockinSettings(
        locationUid,
        clockinUser.uid,
        clockinUser.settings.allowsRemoteClockins,
        !clockinUser.settings.hasFlexibleClockins,
        clockinUser.settings.weeklyClockinHours,
        clockinUser.settings.monthlyClockinHours,
        clockinUser.settings.workLocationPolicy,
    )
}

function updateWeeklyClockinHours(clockinUser = ClockinUser(), locationUid, weeklyClockinHours) {
    return setUserClockinSettings(
        locationUid,
        clockinUser.uid,
        clockinUser.settings.allowsRemoteClockins,
        !clockinUser.settings.hasFlexibleClockins,
        weeklyClockinHours,
        clockinUser.settings.monthlyClockinHours,
        clockinUser.settings.workLocationPolicy,
    )
}

function updateMonthlyClockinHours(clockinUser = ClockinUser(), locationUid, monthlyClockinHours) {
    return setUserClockinSettings(
        locationUid,
        clockinUser.uid,
        clockinUser.settings.allowsRemoteClockins,
        !clockinUser.settings.hasFlexibleClockins,
        clockinUser.settings.weeklyClockinHours,
        monthlyClockinHours,
        clockinUser.settings.workLocationPolicy,
    )
}

function updateWorkLocationPolicy(clockinUser = ClockinUser(), locationUid, workLocationPolicy) {
    return setUserClockinSettings(
        locationUid,
        clockinUser.uid,
        clockinUser.settings.allowsRemoteClockins,
        !clockinUser.settings.hasFlexibleClockins,
        clockinUser.settings.weeklyClockinHours,
        clockinUser.settings.monthlyClockinHours,
        workLocationPolicy,
    )
}

function updateUserClockinSettings(clockinUser = ClockinUser(), locationUid) {
    return setUserClockinSettings(
        locationUid,
        clockinUser.uid,
        clockinUser.settings.allowsRemoteClockins,
        clockinUser.settings.hasFlexibleClockins,
        clockinUser.settings.weeklyClockinHours,
        clockinUser.settings.monthlyClockinHours,
        clockinUser.settings.workLocationPolicy,
    )
}


function setUserClockinSettings(locationUid, userUid, allowsRemoteClockins, hasFlexibleClockins, weeklyClockinHours, monthlyClockinHours, workLocationPolicy) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {

            await clockinService.updateUserSettings(
                locationUid,
                userUid,
                allowsRemoteClockins,
                hasFlexibleClockins,
                weeklyClockinHours,
                monthlyClockinHours,
                workLocationPolicy,
            );

            const { begin, end } = Selectors.getClockinsDateFilter(getState());
            const permission = Selectors.getPermissionSelectedLocation(getState());
            const canManageClockins = appPermissions.canManageClockins(permission);
            await dispatch(ClockinActions.listClockinUsers(locationUid, begin, end, canManageClockins));
        }
    }
}

function showDeletePopUp(uid) {
    return dispatch => {
        dispatch(globalActions.showPopUp(GLOBAL_POPUPS.DELETE_CLOCKIN, { uid }));
    };
}

//LIST
function listClockinUsers(locationUid, begin, end, canManageClockins) {
    return async dispatch => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {

            if (!canManageClockins || !begin || !end)
                return;
            
            const serverClockinUsers = await clockinService.listClockinUsers(
                locationUid,
                begin,
                end,
            );
            
            dispatch(ClockinActions._listClockinUsersSuccess(
                ClockinUserMapper.serverToLocal(serverClockinUsers).sort((userA, userB) => userA.user.name.localeCompare(userB.user.name))
            ));
        }
    }
}

function refreshClockins() {
    return async (dispatch, getState) => {
        const { begin, end } = Selectors.getClockinsDateFilter(getState());
        const userUid = Selectors.getClockinsSelectedUserUid(getState());
        const locationUid = Selectors.getSelectedLocationUid(getState());
        await dispatch(ClockinActions.listClockins(
            locationUid,
            begin,
            end,
            userUid,
        ));
    };
}

function listClockins(locationUid, begin, end, userUid) {
    return async dispatch => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            if (!begin || !end)
                return;

            const serverWorkdays = await clockinService.listClockIns(
                locationUid,
                begin,
                end,
                userUid,
            );
            dispatch(ClockinActions._listClockinsSuccess(
                WorkdayMapper.allServerToLocal(serverWorkdays)
            ));
        }
    };
}

function listVacation(locationUid, begin, end, userUid) {
    return async dispatch => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            if (!begin || !end)
                return;

            const serverVacation = await clockinService.listVacation(
                locationUid,
                begin,
                end,
                userUid,
            );
            dispatch(ClockinActions._listClockinVacationSuccess(
                VacationMapper.allServerToLocal(serverVacation)
            ));
        }
    };
}

function listWorkingCalendarEntries(locationUid, begin, end) {
    return async dispatch => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            if (!begin || !end)
                return;

            const entry = await clockinService.listWorkingCalendarEntries(
                locationUid,
                begin,
                end,
            );
            dispatch(ClockinActions._listClockinWorkingCalendarEntriesSuccess(
                WorkingCalendarEntriesMapper.allServerToLocal(entry)
            ));
        }
    };
}

function listWorkShifts() {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const userUid = Selectors.getClockinsSelectedUserUid(getState());
            const locationUid = Selectors.getSelectedLocationUid(getState());

            const serverWorkShifts = await clockinService.listWorkShifts(
                locationUid,
                userUid,
            );
            dispatch(ClockinActions._listClockinWorkShiftSuccess(
                WorkShiftMapper.mapTimeSlotsServerToLocal(serverWorkShifts)
            ));
        }
    };
}

//EDIT
function createClockInForCurrentUser(date) {
    return async (dispatch, getState) => {
        const selectedUserUid = Selectors.getClockinsSelectedUserUid(getState());
        await dispatch(ClockinActions.createClockIn(selectedUserUid, date));
    };
}

function createClockIn(userUid, date) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const locationUid = Selectors.getSelectedLocationUid(getState());

            await clockinService.createClockIn(locationUid, userUid, date);
            await dispatch(ClockinActions.refreshClockins());
            
            const { begin, end } = Selectors.getClockinsDateFilter(getState());
            const permission = Selectors.getPermissionSelectedLocation(getState());
            const canManageClockins = appPermissions.canManageClockins(permission);
            await dispatch(ClockinActions.listClockinUsers(locationUid, begin, end, canManageClockins));
        }
    };
}

function updateClockIn(uid, date, notes) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await clockinService.updateClockIn(uid, date, notes);
            await dispatch(ClockinActions.refreshClockins());

            const locationUid = Selectors.getSelectedLocationUid(getState());
            const { begin, end } = Selectors.getClockinsDateFilter(getState());
            const permission = Selectors.getPermissionSelectedLocation(getState());
            const canManageClockins = appPermissions.canManageClockins(permission);
            await dispatch(ClockinActions.listClockinUsers(locationUid, begin, end, canManageClockins));
        }
    };
}

function deleteClockIn(uid) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await clockinService.deleteClockIn(uid);
            await dispatch(ClockinActions.refreshClockins());

            const locationUid = Selectors.getSelectedLocationUid(getState());
            const { begin, end } = Selectors.getClockinsDateFilter(getState());
            const permission = Selectors.getPermissionSelectedLocation(getState());
            const canManageClockins = appPermissions.canManageClockins(permission);
            await dispatch(ClockinActions.listClockinUsers(locationUid, begin, end, canManageClockins));
        }
    };
}

function requestVacation(begin, end, type) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const locationUid = Selectors.getSelectedLocationUid(getState());
            const userUid = Selectors.getClockinsSelectedUserUid(getState());

            await clockinService.requestVacation(locationUid, userUid, begin, end, type);
        }
    };
}

function deleteVacation(uid) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await clockinService.deleteVacation(uid);
        }
    };
}

function addWorkingCalendarEntry(begin, end) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const locationUid = Selectors.getSelectedLocationUid(getState());

            await clockinService.addWorkingCalendarEntry(locationUid, begin, end);
        }
    };
}

function deleteWorkingCalendarEntry(uid) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await clockinService.deleteWorkingCalendarEntry(uid);
        }
    };
}

function addWorkShiftSlot(workShiftSlots) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const locationUid = Selectors.getSelectedLocationUid(getState());
            const userUid = Selectors.getClockinsSelectedUserUid(getState());


            await clockinService.addWorkShiftSlot(
                locationUid, 
                userUid, 
                ClockinWorkShiftMapper.mapWorkShiftsLocalToServer(workShiftSlots)
            );
            await dispatch(ClockinActions.listWorkShifts());
        }
    };
}

function deleteWorkShiftSlot(uid) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await clockinService.deleteWorkShiftSlot(uid);

            await dispatch(ClockinActions.listWorkShifts());
        }
    };
}

function uploadContract(locationUid, userUid, file) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await clockinService.uploadContract(locationUid, userUid, file);

            const { begin, end } = Selectors.getClockinsDateFilter(getState());
            const permission = Selectors.getPermissionSelectedLocation(getState());
            const canManageClockins = appPermissions.canManageClockins(permission);
            await dispatch(ClockinActions.listClockinUsers(locationUid, begin, end, canManageClockins));
        }
    };
}

async function deleteContract(locationUid, userUid) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await clockinService.deleteContract(locationUid, userUid);
             const { begin, end } = Selectors.getClockinsDateFilter(getState());
            const permission = Selectors.getPermissionSelectedLocation(getState());
            const canManageClockins = appPermissions.canManageClockins(permission);
            await dispatch(ClockinActions.listClockinUsers(locationUid, begin, end, canManageClockins));
        }
    };
}

function listAuthorizations() {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const userUid = Selectors.getClockinsSelectedUserUid(getState());
            const locationUid = Selectors.getSelectedLocationUid(getState());

            const serverAuthorizations = await clockinService.listAuthorizations(
                locationUid,
                userUid,
            );
            dispatch(ClockinActions._listAuthorizationSuccess(
                AuthorizationMapper.allServerToLocal(serverAuthorizations)
            ));
        }
    };
}
